var _excluded = ["children", "className", "required", "optionalMessage"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import cs from 'classnames';
require("./field-label.css");
var styles = {
  "label": "label-27Swm",
  "labelOptional": "labelOptional-2wrU2"
};
/**
 * This component does not include an input, just a label that is
 * used in multiple components. Thus, no has-associated-control or
 * label-has-for
 */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
var FieldLabel = _ref => {
  var {
      children,
      className,
      required,
      optionalMessage
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var optional = !required && optionalMessage ? /*#__PURE__*/React.createElement("span", {
    className: styles.labelOptional
  }, "(", optionalMessage, ")") : null;
  return /*#__PURE__*/React.createElement("label", _extends({
    className: cs(styles.label, className)
  }, otherProps), children, " ", optional);
};
FieldLabel.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  required: PropTypes.bool.isRequired,
  optionalMessage: PropTypes.string
};
FieldLabel.defaultProps = {
  className: null,
  optionalMessage: null
};
export default FieldLabel;